/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getEligibleToClose} from '../api'

 export const useQueryGetEligibleToClose = createReactQueryHook('getEligibleToClose', getEligibleToClose)
